// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__FZ0nl","title":"BackImages_title__LQfAp","images":"BackImages_images__hv2pU"};